import { Images } from "../../Assets/Index";
import { useDispatch, useSelector } from "react-redux";
import { dispatchtoast, getLocalStorageItem } from "../../Utils";
import { GoHome } from "react-icons/go";
import { Button, Input } from "antd";
import { IoCaretBack, IoHome, IoSearch } from "react-icons/io5";
import { MdChat, MdHome, MdSend } from "react-icons/md";
import { BsChatLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useCommmonStore } from "../../Store/CommonReducer";

const Support = () => {
  const walletBalance = useSelector((state) => state.colorGame.walletBal);
  const withdrawAmount = useSelector((state) => state.colorGame.withdrawAmt);
  const { Search } = Input;
  const navigate = useNavigate();
  const { profileDetail } = useCommmonStore();
  console.log("test support page");
  return (
    <>
      <div className="flex justify-center pb-20 items-center bg-black rounded-lg">
        <div className="w-full ">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/home")}
              />
              <p className="text-xl font-normal custome">
                {getLocalStorageItem("userDetails")?.name}Support
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>
          <div>
            {" "}
            <div>
              <div className=" bg-black h-[80vh]">
                <div className="text-start m-4">
                  <p className="text-white custome text-4xl font-bold">
                    Hi there 👋
                  </p>
                  <p className="text-white custome text-base mt-6 font-thin">
                    Need help? Search our help center for answers or
                  </p>
                  <p className="text-white custome text-base font-thin">
                    start a conversation :
                  </p>
                </div>
                <div
                  className="gap-2 bg-white
                  items-center rounded-lg m-4 p-2  border-none"
                >
                  <div className="shadow-sm m-2 text-start">
                    <p className="text-base text-black custome font-thin ">
                      Help Center
                    </p>
                    <Input
                      placeholder="🔍 Search for answers"
                      className="custom-search custom-placeholder mt-6"
                      style={{ backgroundColor: "white", border: "none" }}
                    />
                  </div>
                </div>
                <div
                  className="gap-2 bg-white
                  grid grid-cols-1 sm:grid-cols-[70%_30%] rounded-lg m-4 p-2  border-none"
                >
                  <div className="shadow-sm m-2 text-start">
                    <p className="text-base text-black custome font-thin ">
                      New Conversation
                    </p>
                    <p className="text-xs text-gray-400 custome mt-2 font-thin ">
                      We typically reply in a few minutes
                    </p>
                  </div>
                  <div className="flex justify-center items-center cursor-pointer">
                    <MdSend className="text-xl" />
                  </div>
                </div>
                <div
                  className="gap-2 bg-white sm:mt-60
                  grid grid-cols-1 sm:grid-cols-2 rounded-lg m-4 p-2  h-20 border-none"
                >
                  <div className="flex justify-center items-center">
                    <GoHome className="text-xl" />
                  </div>
                  <div className="flex justify-center items-center">
                    <BsChatLeft className="text-xl" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
